import { EditorState, ContentState, convertFromHTML } from 'draft-js';

/**
 * Создает EditorState из HTML строки
 * @param {string} htmlString - HTML строка для конвертации
 * @param {string} lang - Язык (для логирования)
 * @returns {EditorState} - EditorState объект
 */
export const createEditorStateFromHTML = (htmlString, lang = '') => {
  try {
    if (!htmlString || typeof htmlString !== 'string') {
      return EditorState.createEmpty();
    }

    // Конвертируем HTML в блоки контента
    const blocksFromHTML = convertFromHTML(htmlString);
    
    if (!blocksFromHTML || !blocksFromHTML.contentBlocks) {
      console.warn(`Failed to convert HTML for ${lang}:`, htmlString);
      return EditorState.createEmpty();
    }

    // Создаем ContentState из блоков
    const contentState = ContentState.createFromBlockArray(
      blocksFromHTML.contentBlocks,
      blocksFromHTML.entityMap
    );

    // Создаем EditorState из ContentState
    return EditorState.createWithContent(contentState);
  } catch (error) {
    console.error(`Error creating EditorState for ${lang}:`, error);
    return EditorState.createEmpty();
  }
};